import type { Account, AccountOwner } from '../../generated-types';

export const getRelevantOwner = (owners?: AccountOwner[]): string | undefined => {
    const primaryOwner = owners?.find((owner) => owner.primaryOwner);
    return primaryOwner?.equalToUserLoggedOn ? undefined : primaryOwner?.name;
};

const groupByRelevantOwner = (accounts: Account[]): Record<string, Account[]> => {
    return accounts.reduce(
        (map, account) => {
            const relevantOwner = getRelevantOwner(account.owners) ?? '';
            const oAccounts = map[relevantOwner] ?? [];

            return {
                ...map,
                [relevantOwner]: oAccounts.concat([account]),
            };
        },
        {} as Record<string, Account[]>,
    );
};

const sortBySortKey = (a: Account, b: Account) => {
    const aNoSortKey = a.sortKey === undefined || a.sortKey.value === 0;
    const bNoSortKey = b.sortKey === undefined || b.sortKey.value === 0;
    if (aNoSortKey && bNoSortKey) {
        return 0;
    }
    if (aNoSortKey) {
        return 1;
    }
    if (bNoSortKey) {
        return -1;
    }
    return a.sortKey!.value - b.sortKey!.value;
};

const sortAccounts = (accounts: Account[]): Account[] => {
    const groupedAccounts = groupByRelevantOwner(accounts);
    const sortedOwners = Object.keys(groupedAccounts).sort();

    return sortedOwners
        .reduce((list, owner) => {
            return [...list, ...groupedAccounts[owner]];
        }, [] as Account[])
        .sort(sortBySortKey);
};

export default sortAccounts;
